<template>
  <div class="buyin-container">
    <div style="display: flex">
      <div class="header-wrap">
        <div class="header">
          <div class="logo">
            <XLogo />
          </div>
          <ul class="menu">
            <router-link
              tag="li"
              class="item"
              v-for="(n, i) in list"
              :key="i"
              :to="n.link || '#'"
              active-class="selected"
            >
              <span class="text">{{ n.name }}</span>
            </router-link>
          </ul>
        </div>
      </div>

      <div class="content">
        <section class="layout">
          <router-view />
        </section>
      </div>
    </div>
  </div>
</template>
<script>
import XLogo from "./components/logo";
export default {
  components: {
    XLogo,
  },
  data() {
    return {
      list: [
        {
          name: "首页"
        },
        {
          name: "直播管理",
          link: "/simulation/buyin/live/",
        },
        {
          name: "作者成长",
        },
        {
          name: "精选联盟",
        },
        {
          name: "数据参谋",
        },
        {
          name: "平台活动",
        },
        {
          name: "抖音电商学习中心",
        },
      ],
    };
  },
};
</script>
<style lang="less">
html,
body,
#app {
  height: 100%;
}
</style>
<style lang="less" scoped>
.buyin-container {
  min-height: 100%;
  background-color: #f7f8fc;

  .header-wrap {
    background-color: #fff;
    height: 64px;
    padding: 0;
    transition: box-shadow 0.3s;
    width: 100%;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 3%);
    left: 0;
    position: fixed;
    top: 0;
    z-index: 999;
    color: #515361;
    line-height: 64px;

    .header {
      display: flex;
      justify-content: space-between;
      margin: 0 auto;
      padding: 0 28px;
      width: 100%;
      align-items: center;

      .logo {
        margin-top: 0;
        align-items: center;
        cursor: pointer;
        display: flex;
        float: left;
        margin-right: 80px;
        min-width: 180px;
      }

      .menu {
        background: transparent;
        border: none;
        border-radius: 4px;
        margin-right: 24px;
        white-space: nowrap;
        line-height: inherit;
        flex: 1 1;
        height: 64px;
        padding: 0 80px 0 0 !important;
        position: relative;
        box-shadow: none;
        box-sizing: border-box;
        color: #515361;
        font-size: 14px;
        list-style: none;
        margin: 0;
        outline: none;
        text-align: left;
        transition: background 0.3s, width 0.3s cubic-bezier(0.2, 0, 0, 1) 0s;

        &::before {
          content: "";
          display: table;
        }

        .item {
          color: #131520;
          font-size: 14px;
          display: inline-block;
          position: relative;
          top: 1px;
          vertical-align: bottom;
          border-bottom: none;
          font-weight: 400;
          line-height: 64px;
          margin: 0;
          padding: 0 20px;
          cursor: pointer;
          white-space: nowrap;

          &:hover {
            border-radius: 4px;
            color: #6557fa !important;
          }

          &.selected {
            border-radius: 4px;
            color: #6557fa;
            font-weight: 500;
          }

          .text {
            position: relative;
          }
        }
      }
    }
  }

  .content {
    // width: 1144px;
    // max-width: 1336px;
    margin: 64px auto 0;
    .layout {
      //   background: #f0f2f5;
      display: flex;
      flex: auto;
      min-height: calc(100% - 64px) !important;
    }
  }
}
</style>